/* ============
 * City Transformer
 * ============
 */

import Transformer from './transformer';
import countryTransformer from './country';

export default class SupplierAddressTransformer extends Transformer {

  static fetch(address) {
    return {
      id: address.id,
      streetName1: address.street_name_1,
      streetName2: address.street_name_2,
      countryId: address.country_id,
      city: address.city,
      postalCode: address.postal_code,
      country: address.country !== undefined ? countryTransformer.fetch(address.country) : [],
    };
  }

  static send(item) {
    return {
      street_name_1: item.streetName1,
      street_name_2: item.streetName2,
      country_id: item.countryId,
      city: item.city,
      postal_code: item.postalCode,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/supplierAddress.js